<template>
  <div class="page-wrapper">
    <div class="content" v-if="certificateInfo">
      <div class="pt16 pb16">
        <h4 class="mb8">缴费凭证信息</h4>
        <Row>
          <Col span="8">收款单号：<span class="info">{{certificateInfo.receiptNum}}</span></Col>
          <Col span="8">单据状态：<span class="info">{{certificateInfo.receiptStatusName}}</span></Col>
          <Col span="8">审核状态：<span class="info">{{certificateInfo.confirmStatusName}}</span></Col>
          <Col span="8">审核日期：<span class="info">{{certificateInfo.confirmTime}}</span></Col>
          <Col span="8">收款金额：<span class="info">{{(certificateInfo.totalAmount/100).toFixed(2)}}</span></Col>
          <Col span="8">实际支付日期：<span class="info">{{certificateInfo.payTime}}</span></Col>
          <Col span="8">制单人：<span class="info">{{certificateInfo.makerName}}</span></Col>
          <Col span="8">制单日期：<span class="info">{{certificateInfo.createTime}}</span></Col>
          <Col span="8">收款方式：<span class="info">{{certificateInfo.paymentTypeCodeName}}</span></Col>
          <!--<Col span="8" >参考号：<span class="info">{{certificateInfo.referenceNum}}</span></Col>-->
          <Col span="8" v-if="payTypeCode!==3">付款人：<span class="info">{{certificateInfo.payer}}</span></Col>
          <Col span="8" v-if="payTypeCode===0">汇入账户：<span class="info">{{certificateInfo.bankAccount}}</span></Col>
          <Col span="8" v-if="payTypeCode === 1">终端号：<span class="info">{{certificateInfo.terminalNo}}</span></Col>
          <Col span="8" v-if="payTypeCode!==4">{{paySerialLabel}}：<span
            class="info">{{payTypeCode===1?certificateInfo.referenceNum:certificateInfo.paySerialNum}}</span></Col>
        </Row>
      </div>
      <div class="pt16 pb16">
        <table-list
          :title="'应收账单详情'"
          :columns="columns"
          :data="tableData"
          :loading="false"
          :show-page="false"
        >
        </table-list>
      </div>
      <div class="pt16 pb16">
        <p v-if="certificateInfo.reason">打回原因：<span class="info">{{certificateInfo.reason}}</span></p>
        <p v-if="certificateInfo.remark">备注：<span class="info">{{certificateInfo.remark}}</span></p>
        <div class="flex mt12">
          附件：
          <div class="annexList mr8" v-for="(item,i) in certificateInfo.annexList" :key="`annex${i}`">
            <img class="file-img" :src="item" @click.stop="showImg(item)"/>
          </div>
        </div>
      </div>
    </div>
    <img-show :n="imgN" :src="imgSrc"></img-show>
  </div>
</template>

<script type="text/ecmascript-6">
  import {certificateDetail} from 'api/accountsReceivable'
  import TableList from 'components/TableList/index';
  import ImgShow from 'components/ImgShow/index'

  export default {
    name: 'certificatedetail',
    created() {
      this.projectFid = this.$route.query.proId
      this.billNum = this.$route.query.bNum
      this.getDetail()
    },
    activated() {
      if (this.isActive) {
        this.projectFid = this.$route.query.proId
        this.billNum = this.$route.query.bNum
        this.getDetail()
      } else {
        this.isActive = true
      }
    },
    components: {
      TableList,
      ImgShow
    },
    computed: {
      payTypeCode() {
        let payType = this.payType
        let type = 0 // type:0银行，1pos机，2支票,3虚拟抵扣,4租金卡
        let patternYh = /^yhzz/
        let patternZp = /^zp/
        let patternPos = /^pos/
        let patternXndk = /^mzjxndk/
        let patternCard = /^card$/
        if (patternYh.test(payType)) {
          type = 0
        } else if (patternPos.test(payType)) {
          type = 1
        } else if (patternZp.test(payType)) {
          type = 2
        } else if (patternXndk.test(payType)) {
          type = 3
        } else if (patternCard.test(payType)) {
          type = 4
        }
        return type
      },
      paySerialLabel() {
        let label = ''
        switch (this.payTypeCode) {
          case 0 :
            label = '付款账号'
            break;
          case 1 :
            label = '参考号'
            break;
          case 2 :
            label = '支票号'
            break;
          case 3 :
            label = 'OA审批申请号'
            break;
          default:
            label = '付款账号'
        }
        return label
      }
    },
    data() {
      return {
        imgN:0,
        imgSrc:'',

        isActive: false,
        projectFid: '',
        billNum: '',
        certificateInfo: null,
        payType: '',
        tableData: [],
        columns: [
          {
            title: '应收账单编号',
            key: 'billNum',
            align: 'center'
          },
          {
            title: '合同号',
            key: 'outContractCode',
            align: 'center'
          },
          {
            title: '房间/床位',
            key: 'stockNumber',
            align: 'center'
          },
          {
            title: '费用项',
            key: 'costCodeName',
            align: 'center'

          },
          {
            title: '实收金额',
            key: 'receivedBillAmount',
            align: 'center',
            render: (h, params) => {
              return h('span', (params.row.receivedBillAmount / 100).toFixed(2))
            }
          },
        ]
      };
    },
    methods: {
      showImg(src){
        this.imgSrc=src
        this.imgN++
      },
      getDetail() {
        certificateDetail(this.projectFid, this.billNum).then(res => {
          this.certificateInfo = res.data
          this.payType = res.data.paymentTypeCode
          this.tableData = res.data.receiptList
        })
      }
    }
  }
</script>

<style lang="css" scoped>
  .info {
    padding-left: 8px;
    font-weight: 600;
  }

  .annex-list {
    display: inline-block;
  }

  .ivu-col, p {
    line-height: 2.5;
  }
</style>
